import { render } from "./YakitPompasi.vue?vue&type=template&id=2d1b03b9"
import script from "./YakitPompasi.vue?vue&type=script&lang=js"
export * from "./YakitPompasi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__